export default __webpack_public_path__ + "static/media/pueblo-of-jemez.37804d42.jpg";